<template>
  <div class="header">
    <div class="title">
      <p class="name">{{conversation.name}}</p>
    </div>
  </div>
</template>

<script>
  import {mapState} from 'vuex';
  export default {
    computed:{
      ...mapState({
        conversation:state=>state.conversation.currentConversation
      })
    }
  }
</script>

<style lang="scss" scoped>
  .header {
    line-height: 30px;
    .title {
      padding: 10px 0;
      margin: 0 19px;
      border-bottom: 1px solid #d6d6d6;
      .name {
        font-size: 14px;
        height: 30px;
        text-align: center;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/page/chat/components/header.vue